import type { SVGProps } from "react";

export function IconBluePackageBase(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="7"
        y="7"
        width="50"
        height="50"
        fill="#41D8F6"
        stroke="#41D8F6"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M27 7V18H37V7"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M50 34H38M50 34V46M50 34L40.9449 43.0551C37.7787 46.2213 33.4845 48 29.0069 48H28C20.268 48 14 41.732 14 34V34"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
